import { render, staticRenderFns } from "./TopThree.vue?vue&type=template&id=1244e66f&"
import script from "./TopThree.vue?vue&type=script&lang=js&"
export * from "./TopThree.vue?vue&type=script&lang=js&"
import style0 from "./TopThree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports